// AUTO-GENERATED — do not edit. Run: pnpm generate:tokens
// Source: src/styles/tokens/semantics.css

export const sdwebTokens = {
    action: {
        confirm: 'var(--action-confirm)',
    },
    activity: {
        lineAlarm: 'var(--activity-line-alarm)',
        lineWarning: 'var(--activity-line-warning)',
        lineManual: 'var(--activity-line-manual)',
        lineAutomatic: 'var(--activity-line-automatic)',
        lineMachineiq: 'var(--activity-line-machineiq)',
        lineMultiple: 'var(--activity-line-multiple)',
        lineCreationMarker: 'var(--activity-line-creation-marker)',
        lineCriticalAlarm: 'var(--activity-line-critical-alarm)',
    },
    analysis: {
        markerRuler: 'var(--analysis-marker-ruler)',
        marker1x: 'var(--analysis-marker-1x)',
        markerBpfo: 'var(--analysis-marker-bpfo)',
        markerBpfi: 'var(--analysis-marker-bpfi)',
        markerBsf: 'var(--analysis-marker-bsf)',
        markerFtf: 'var(--analysis-marker-ftf)',
        marker2xlf: 'var(--analysis-marker-2xlf)',
        markerLf: 'var(--analysis-marker-lf)',
        markerPpf: 'var(--analysis-marker-ppf)',
        markerRbf: 'var(--analysis-marker-rbf)',
        markerSspf: 'var(--analysis-marker-sspf)',
    },
    asset: {
        normal: 'var(--asset-normal)',
        warning: 'var(--asset-warning)',
        alarm: 'var(--asset-alarm)',
        critical: 'var(--asset-critical)',
        monitored: 'var(--asset-monitored)',
    },
    border: {
        subtle: 'var(--border-subtle)',
        default: 'var(--border-default)',
        strong: 'var(--border-strong)',
        hover: 'var(--border-hover)',
    },
    card: {
        border: 'var(--card-border)',
        background: 'var(--card-background)',
    },
    charts: {
        '1': 'var(--charts-1)',
        '2': 'var(--charts-2)',
        '3': 'var(--charts-3)',
        '4': 'var(--charts-4)',
        '5': 'var(--charts-5)',
        '6': 'var(--charts-6)',
        '7': 'var(--charts-7)',
        '8': 'var(--charts-8)',
        '9': 'var(--charts-9)',
        '10': 'var(--charts-10)',
        '11': 'var(--charts-11)',
        '12': 'var(--charts-12)',
        '13': 'var(--charts-13)',
        '14': 'var(--charts-14)',
        '15': 'var(--charts-15)',
        '16': 'var(--charts-16)',
        '17': 'var(--charts-17)',
        '18': 'var(--charts-18)',
        '19': 'var(--charts-19)',
        '20': 'var(--charts-20)',
    },
    custom: {
        marker1: 'var(--custom-marker-1)',
        marker2: 'var(--custom-marker-2)',
        marker3: 'var(--custom-marker-3)',
        marker4: 'var(--custom-marker-4)',
        faultMarker: 'var(--custom-fault-marker)',
    },
    foreground: {
        inverse: 'var(--foreground-inverse)',
    },
    health: {
        rangeUnspecified: 'var(--health-range-unspecified)',
        rangeOff: 'var(--health-range-off)',
        rangeHealthy: 'var(--health-range-healthy)',
        rangeFaultDeveloping: 'var(--health-range-fault-developing)',
        rangeUnhealthy: 'var(--health-range-unhealthy)',
    },
    history: {
        issueBackground: 'var(--history-issue-background)',
        issueIcon: 'var(--history-issue-icon)',
        taskBackground: 'var(--history-task-background)',
        taskIcon: 'var(--history-task-icon)',
        alertBackground: 'var(--history-alert-background)',
        alertIcon: 'var(--history-alert-icon)',
    },
    icon: {
        onColor: 'var(--icon-on-color)',
        default: 'var(--icon-default)',
        secondary: 'var(--icon-secondary)',
        primary: 'var(--icon-primary)',
        positive: 'var(--icon-positive)',
    },
    indicator: {
        thresholdOff: 'var(--indicator-threshold-off)',
        thresholdAlarm: 'var(--indicator-threshold-alarm)',
        thresholdWarning: 'var(--indicator-threshold-warning)',
        thresholdCriticalAlarm: 'var(--indicator-threshold-critical-alarm)',
    },
    lozenge: {
        blueBackground: 'var(--lozenge-blue-background)',
        blueColor: 'var(--lozenge-blue-color)',
        greenBackground: 'var(--lozenge-green-background)',
        greenColor: 'var(--lozenge-green-color)',
        purpleBackground: 'var(--lozenge-purple-background)',
        purpleColor: 'var(--lozenge-purple-color)',
        turquoiseBackground: 'var(--lozenge-turquoise-background)',
        turquoiseColor: 'var(--lozenge-turquoise-color)',
        red1Background: 'var(--lozenge-red-1-background)',
        red1Color: 'var(--lozenge-red-1-color)',
        red2Background: 'var(--lozenge-red-2-background)',
        red2Color: 'var(--lozenge-red-2-color)',
        orange1Background: 'var(--lozenge-orange-1-background)',
        orange1Color: 'var(--lozenge-orange-1-color)',
        orange2Background: 'var(--lozenge-orange-2-background)',
        orange2Color: 'var(--lozenge-orange-2-color)',
        orange3Background: 'var(--lozenge-orange-3-background)',
        orange3Color: 'var(--lozenge-orange-3-color)',
        grey1Background: 'var(--lozenge-grey-1-background)',
        grey1Color: 'var(--lozenge-grey-1-color)',
        grey2Background: 'var(--lozenge-grey-2-background)',
        grey2Color: 'var(--lozenge-grey-2-color)',
        grey3Background: 'var(--lozenge-grey-3-background)',
        grey3Color: 'var(--lozenge-grey-3-color)',
        grey4Background: 'var(--lozenge-grey-4-background)',
        grey4Color: 'var(--lozenge-grey-4-color)',
        grey5Background: 'var(--lozenge-grey-5-background)',
        grey5Color: 'var(--lozenge-grey-5-color)',
        removeBackgroundHover: 'var(--lozenge-remove-background-hover)',
        removeIconHover: 'var(--lozenge-remove-icon-hover)',
    },
    metric: {
        newBackground: 'var(--metric-new-background)',
        newIcon: 'var(--metric-new-icon)',
        openBackground: 'var(--metric-open-background)',
        openIcon: 'var(--metric-open-icon)',
        resolvedBackground: 'var(--metric-resolved-background)',
        resolvedIcon: 'var(--metric-resolved-icon)',
        draftBackground: 'var(--metric-draft-background)',
        draftIcon: 'var(--metric-draft-icon)',
        daysBackground: 'var(--metric-days-background)',
        daysIcon: 'var(--metric-days-icon)',
        downtimeBackground: 'var(--metric-downtime-background)',
        downtimeIcon: 'var(--metric-downtime-icon)',
        savingsBackground: 'var(--metric-savings-background)',
        savingsIcon: 'var(--metric-savings-icon)',
        severeBackground: 'var(--metric-severe-background)',
        severeIcon: 'var(--metric-severe-icon)',
    },
    misc: {
        favorite: 'var(--favorite)',
    },
    nav: {
        primaryBackground: 'var(--nav-primary-background)',
        secondaryBackground: 'var(--nav-secondary-background)',
        secondarySelected: 'var(--nav-secondary-selected)',
        secondaryItemSelected: 'var(--nav-secondary-item-selected)',
        border: 'var(--nav-border)',
        text: 'var(--nav-text)',
        icon: 'var(--nav-icon)',
        chevron: 'var(--nav-chevron)',
        textSelected: 'var(--nav-text-selected)',
        hoverBackground: 'var(--nav-hover-background)',
        popupBackground: 'var(--nav-popup-background)',
        popupShadow: 'var(--nav-popup-shadow)',
        itemSize: 'var(--nav-item-size)',
        expandedWidth: 'var(--nav-expanded-width)',
    },
    on: {
        primary: 'var(--on-primary)',
        error: 'var(--on-error)',
        success: 'var(--on-success)',
        warning: 'var(--on-warning)',
    },
    popup: {
        arrowStroke: 'var(--popup-arrow-stroke)',
        arrowShadow: 'var(--popup-arrow-shadow)',
        border: 'var(--popup-border)',
    },
    priority: {
        '1': 'var(--priority-1)',
        '2': 'var(--priority-2)',
        '3': 'var(--priority-3)',
        '4': 'var(--priority-4)',
        '5': 'var(--priority-5)',
    },
    resolution: {
        resolved: 'var(--resolution-resolved)',
        removed: 'var(--resolution-removed)',
    },
    savings: {
        green: 'var(--savings-green)',
    },
    severity: {
        critical: 'var(--severity-critical)',
        alarm: 'var(--severity-alarm)',
        moderate: 'var(--severity-moderate)',
        low: 'var(--severity-low)',
    },
    skeleton: {
        base: 'var(--skeleton-base)',
        highlight: 'var(--skeleton-highlight)',
    },
    status: {
        draft: 'var(--status-draft)',
        draftText: 'var(--status-draft-text)',
        new: 'var(--status-new)',
        open: 'var(--status-open)',
        closed: 'var(--status-closed)',
        wontFix: 'var(--status-wont-fix)',
        notAnIssue: 'var(--status-not-an-issue)',
        removed: 'var(--status-removed)',
    },
    surface: {
        placeholder: 'var(--surface-placeholder)',
        subtle: 'var(--surface-subtle)',
        secondary: 'var(--surface-secondary)',
        dark: 'var(--surface-dark)',
    },
    text: {
        onColor: 'var(--text-on-color)',
        primaryInverse: 'var(--text-primary-inverse)',
    },
    timeseries: {
        background: 'var(--timeseries-background)',
        axis: 'var(--timeseries-axis)',
        grid: 'var(--timeseries-grid)',
    },
    trend: {
        indicators1: 'var(--trend-indicators-1)',
        indicators2: 'var(--trend-indicators-2)',
        indicators3: 'var(--trend-indicators-3)',
        indicators4: 'var(--trend-indicators-4)',
        indicators5: 'var(--trend-indicators-5)',
        indicators6: 'var(--trend-indicators-6)',
        indicators7: 'var(--trend-indicators-7)',
        indicators8: 'var(--trend-indicators-8)',
        indicators9: 'var(--trend-indicators-9)',
        indicators10: 'var(--trend-indicators-10)',
        indicators11: 'var(--trend-indicators-11)',
        indicators12: 'var(--trend-indicators-12)',
        indicators13: 'var(--trend-indicators-13)',
        indicators14: 'var(--trend-indicators-14)',
        indicators15: 'var(--trend-indicators-15)',
        indicators16: 'var(--trend-indicators-16)',
        indicators17: 'var(--trend-indicators-17)',
        indicators18: 'var(--trend-indicators-18)',
        indicators19: 'var(--trend-indicators-19)',
        indicators20: 'var(--trend-indicators-20)',
    },
} as const;

export type SdwebTokens = typeof sdwebTokens;
